import { ETableSpotPriceCategory } from '@core/type/api';

export const DYNAMIC_TRANSLATIONS = {
  [ETableSpotPriceCategory.CURRENCIES]: 'tableMetalPrice.currencies',
  [ETableSpotPriceCategory.CARATS]: 'tableMetalPrice.carats',
  [ETableSpotPriceCategory.WEIGHT]: 'tableMetalPrice.weight',
};
